import { render, staticRenderFns } from "./freightChargesInfo.vue?vue&type=template&id=6b67906c&scoped=true&"
import script from "./freightChargesInfo.vue?vue&type=script&lang=js&"
export * from "./freightChargesInfo.vue?vue&type=script&lang=js&"
import style0 from "./freightChargesInfo.vue?vue&type=style&index=0&id=6b67906c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b67906c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b67906c')) {
      api.createRecord('6b67906c', component.options)
    } else {
      api.reload('6b67906c', component.options)
    }
    module.hot.accept("./freightChargesInfo.vue?vue&type=template&id=6b67906c&scoped=true&", function () {
      api.rerender('6b67906c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uiCustom/se/hbl/freightChargesInfo.vue"
export default component.exports